var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42.951 112.163h407.883v60.763h-407.883z",
    fill: "#b46f3d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390.834 112.163h60v60.763h-60z",
    fill: "#ab6839"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55.825 406.751h-25.748c-3.314 0-6-2.686-6-6v-266.674l18.874-10 18.874 10v266.674c0 3.314-2.687 6-6 6z",
    fill: "#d68b56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m463.707 406.751h-25.747c-3.314 0-6-2.686-6-6v-266.674l18.874-10 18.874 10v266.674c-.001 3.314-2.687 6-6.001 6z",
    fill: "#ca7b44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m491 134.077h-21.293l-8.128-.015-.5.015h-455.079c-3.314 0-6-2.686-6-6v-31.828c0-3.314 2.686-6 6-6h485c3.314 0 6 2.686 6 6v31.827c0 3.314-2.686 6.001-6 6.001z",
    fill: "#e0a57f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m491 90.249h-30c3.314 0 6 2.686 6 6v31.827c0 3.314-2.686 6-6 6h30c3.314 0 6-2.686 6-6v-31.827c0-3.314-2.686-6-6-6z",
    fill: "#d68b56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFlat);
export default __webpack_public_path__ + "static/media/table-flat.d4b0a2b66cadcfc9fede742185191e79.svg";
export { ForwardRef as ReactComponent };